import {css} from '@emotion/core';
import styled from '@emotion/styled';
import { white, lightBlue, gray, darkBlue } from '@css/constants';
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles';

export const CheckboxWrapper = styled('div')(css`
  width: 100%;
  margin: 0 auto;
`);

export const Checkmark = styled('span')<{ size: 'small' | 'big' }>(props => css`
  border-radius: 3px;
  position: absolute;
  top: 4px;
  left: 0;
  border: ${props.size === 'big' ? 2 : 1}px solid ${gray};
  transition: 0.5s;
  height: ${props.size === 'big' ? 32 : 16}px;
  width: ${props.size === 'big' ? 32 : 16}px;
  background: ${white};
`);

export const Input = styled('input')(css`
  cursor: pointer;
  opacity: 0;
  position: absolute;
  height: 0;
  width: 0;

  &:checked ~ ${Checkmark} {
    background-color: ${lightBlue};
    border-color: ${lightBlue};
  }

  &:focus ~ ${Checkmark} {
    box-shadow: 0 0 0 1px ${darkBlue};
  }
`);

export const Label = styled('label')<{ size: 'small' | 'big'}>(props => css`
  ${fontSize(props.size === 'big' ? 18 : 15)};
  ${FontNormal(500)};
  cursor: pointer;
  display: block;
  text-align: left;
  padding: ${props.size === 'big' ? '10px 0 0 58px' : '5px 0 0 28px'};
  position: relative;
  user-select: none;
  height: ${props.size === 'big' ? 32 : 20}px;
  width: fit-content;

  &:hover ${Checkmark} {
    background-color: ${gray};

    &:after {
      border-color: ${gray};
    }
  }

  &:hover ${Input}:checked ~ ${Checkmark} {
    background-color: ${lightBlue};
    border-color: ${lightBlue};
  }

  &:after {
    position: absolute;
    content: "";
    left: ${props.size === 'big' ? 14 : 7}px;
    top: ${props.size === 'big' ? 14 : 7}px;
    width: ${props.size === 'big' ? 5 : 3}px;
    height: ${props.size === 'big' ? 7 : 8}px;
    border: solid ${white};
    border-width: ${props.size === 'big' ? '0 3px 3px 0' : '0 2px 2px 0'};
    transform: rotate(45deg);
  }
`);
